import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  borderedBox: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down(theme.size.sm)]: {
      flexDirection: 'column',
    },
  },
  flex: {
    flex: 1,
    marginBottom: 30,
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down(theme.size.sm)]: {
      width: '100%',
      marginRight: 0,
    },
  },
  column: {
    flexDirection: 'column',
  },
  roleSection: {
    flexDirection: 'row',
  },
  titledBox: {
    maxWidth: '100%',
    flexBasis: '100%',
    marginRight: 0,
  },
  fileloaderBox: {
    minHeight: 100,
  },
  p0: {
    padding: 0,
  },
  p10: {
    padding: 10,
  },
  max50: {
    maxWidth: 'calc(50% - 30px)',
    [theme.breakpoints.down(theme.size.sm)]: {
      maxWidth: '100%',
    },
  },
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    [theme.breakpoints.down(theme.size.sm)]: {
      flexDirection: 'column',
    },
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(theme.size.xs)]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  ml10: {
    marginLeft: 10,
  },
  mr20: {
    marginRight: 20,
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    background: theme.custom.darkBlue,
    borderRadius: '50%',
  },
  successTitle: {
    fontSize: 19,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  checkIcon: {
    fontSize: '2.5rem',
    color: '#fff',
  },
  recepientsWrapper: {
    [theme.breakpoints.down(theme.size.sm)]: {
      marginBottom: 30,
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  description: {
    margin: '10px 0',
    fontSize: 14,
    color: theme.custom.darkBlue,
  },
  ml20: {
    marginLeft: 20,
  },
  sendCheckboxUl: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  checboxContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginTop: 30,
    [theme.breakpoints.down(theme.size.xs)]: {
      flexDirection: 'column',
    },
  },
  checkboxList: {
    [theme.breakpoints.down(theme.size.xs)]: {
      width: '100%',
      marginBottom: 30,
      marginLeft: 0,
    },
  },
  checkboxField: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
    height: 30,
  },
  checkboxLabel: {
    marginLeft: 10,
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
  label: {
    display: 'block',
    marginBottom: 15,
    fontSize: 14,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  fieldWrapper: {
    marginBottom: 30,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  btn: {
    marginRight: 20,
    background: theme.custom.accept,
    '&:last-child': {
      marginRight: 0,
    },
  },
}));

export const useActionToolbarStyles = makeStyles((theme) => ({
  btnsWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 40,
    marginBottom: 17,
    [theme.breakpoints.down(theme.size.xs)]: {
      marginLeft: 0,
    },
  },
  btn: {
    marginRight: 20,
    background: theme.custom.accept,
    '&:last-child': {
      marginRight: 0,
    },
  },
}));
